import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';
import { getNavigationService } from '../../../../../services/get-navigation.service';
import { AppNavigation } from '../interfaces/navigation.interface';
// import { FilterSelectedValue } from "../../../../../hooks/filters/interfaces/filter-selected-value.interface";
// import { FILTER_NAMES, useAppSimpleFilterSelectedValue } from "../../filters/hooks/use-filter-panel-selection.hook";
import {
  selectLeftNavigation,
  selectTopNavigation,
} from '../selectors/navigation.selectors';

const NAV = 'nav/REACT_QUERY_KEY';
//const defFilterSel: FilterSelectedValue[] = []
interface NavigationData {
  data: AppNavigation[] | undefined;
  isFetched: boolean;
}
export const useAppNav = (): NavigationData => {
  // const marketLevel = useAppSimpleFilterSelectedValue(FILTER_NAMES.MARKETLEVEL)
  // const market = useAppSimpleFilterSelectedValue(FILTER_NAMES.MARKET)
  // const filterSel = useMemo(() => market && marketLevel ? [marketLevel, market] : defFilterSel, [marketLevel, market])
  // const [enabled, setEnabled] = useState(false)
  // useEffect(() => {
  //     if (filterSel.length > 0) {
  //         setEnabled(true)
  //     }
  // }, [filterSel])

  const { data, isFetched } = useQuery({
    queryKey: [NAV],
    queryFn: () => getNavigationService(),
    //enabled,
    refetchOnWindowFocus: false,
  });

  return { data, isFetched } as NavigationData;
};
interface AppNavResult {
  appNav: AppNavigation[];
  isFetched: boolean;
}

export const useAppLeftNav = (): AppNavResult => {
  return useAppFilterNav({ filter: selectLeftNavigation });
};

export const useAppTopNav = (): AppNavResult => {
  return useAppFilterNav({ filter: selectTopNavigation });
};

interface AppNavFilter {
  filter: (state: AppNavigation[]) => AppNavigation[];
}

export const useAppFilterNav = ({
  filter,
}: AppNavFilter): { appNav: AppNavigation[]; isFetched: boolean } => {
  const [appNav, setMenuList] = useState<AppNavigation[]>([]);
  const { data, isFetched } = useAppNav();
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (data !== undefined && isFetched) {
      setMenuList(filter(data));
      setFinished(true);
    }
  }, [data, filter, isFetched]);

  return { appNav, isFetched: finished };
};

export const useAppNavChildren = (appNav: AppNavigation[]) => {
  const children = useMemo(() => {
    const map: Record<string, AppNavigation[]> = {};
    appNav.forEach((i) => {
      const id = i.id;
      const c = appNav.filter((m) => m.id !== id && m.parentId === id);
      if (c && c.length > 0) {
        map[id] = c;
      }
    });
    return map;
  }, [appNav]);

  const parents = useMemo(() => {
    return appNav.filter(
      (m) => m.parentId === undefined || m.parentId === null,
    );
  }, [appNav]);

  return { parents, children };
};
